
export const commonConstants = {
  CHARACTERS: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
};

export const ROUNDING_PRINCIPLE = {
  FLOOR: "FLOOR",
  CEILING: "CEILING",
  HALF_ROUND_UP: "HALF_ROUND_UP",
  HALF_ROUND_DOWN: "HALF_ROUND_DOWN",
};

export const VENDING_SYSTEM = {
  ALLIANCE: "ALLIANCE",
  INTERNAL: "INTERNAL"
}

export const PRODUCT_CATEGORY = {
  GOODS: "GOODS",
  SERVICE: "SERVICE",
  MATERIAL: "MATERIAL",
}
